import FSCss from "../../css/overview.module.css";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as GreenDot } from "../../assets/icons/greenDotSmall.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { Tooltip } from "../../../myfin_v2/elements/Tooltip";
import { ReactComponent as AddIcon } from "../../assets/icons/whitePlus.svg";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";
import commoncss from "../../css/common.module.css";
import { ReactComponent as BackArrow } from "../../assets/icons/left_arrow.svg";
import { ReactComponent as ReplyIcon } from "../../assets/icons/DirectionalArrows.svg";
import { ReactComponent as RecycleBinIcon } from "../../assets/icons/delete_icon_primary.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import Modal from "../../../myfin_v2/elements/Modal";
import Breadcrumb from "../Breadcrumb";
import SocieConfigModal from "../templateLibrary/SocieConfigModal";
import PresetChoiceModal from "./Presets/PresetChoiceModal";
import ExistingPresetModal from "./Presets/ExistingPresetModal";
import NewPresetModal from "./Presets/NewPresetModal";
import SuccessPopup from "../../elements/SuccessPopup";
import DeletePopup from "../../elements/DeletePopup";
import ErrorPopup from "../../elements/ErrorPopup";
import axios from "axios";
const getCategoryName = (cat) => {
  switch(cat) {
    case "BS": return "Balance Sheet";
    case "PL": return "P&L Statement";
    case "general notes": return "General Notes";
    case "BS notes": return "Balance Sheet Notes";
    case "PL notes": return "P&L Statement Notes";
    case "socie": return "SOCIE";
    case "cashflow": return "CashFlow";
    case "disclosure": return "Disclosures";
    case "checklist": return "Checklist";
    default: return cat;
  }
}

const EMPTY_ARRAY = [];

const FSTopBar = ({history, activeCat, showCashflowWorkings, onToggleCashflowWorkings, showAdjustmentLog,   showAddAdjustment, 
  onOpenAdjustmentLog, onAddAdjustment,
  onBackFromAdjustmentLog, showBin, onOpenBin, onBackFromBin, activeBinSection, selectedBinCount, onDeletePermanently, onRestoreSelected,
  socieRows = EMPTY_ARRAY, socieColumns = EMPTY_ARRAY, onSocieConfigSaved}) => {
  const [showConfigureModal, setShowConfigureModal] = useState(false);
  const [showPresetChoiceModal, setShowPresetChoiceModal] = useState(false);
  const [showExistingPresetModal, setShowExistingPresetModal] = useState(false);
  const [showNewPresetModal, setShowNewPresetModal] = useState(false);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorTitle, setErrorTitle] = useState("Error");
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const workspace_data = useSelector((state) => state.WSReducer);
  const { projectData } = useSelector((state) => state.ADJStandaloneReducer);
  const redux_tb_id = useSelector((state) => state.reducer?.tb_id);
  const project_id = sessionStorage.getItem("project_id") || localStorage.getItem("project_id");
  const tb_id = redux_tb_id || sessionStorage.getItem("tb_id") || localStorage.getItem("tb_id");

  const sessProjectId = sessionStorage.getItem("adj_project_id");
  const isMatchingSession = !sessProjectId || sessProjectId === project_id;

  const getInitialStandaloneName = () => {
    if (projectData?.project_name && projectData.project_name !== "Financial Statement") {
      return projectData.project_name;
    }
    if (isMatchingSession) {
      const sess = sessionStorage.getItem("adj_standalone_name");
      if (sess && sess !== "Financial Statement") return sess;
    }
    const loc1 = localStorage.getItem("projectName");
    if (loc1 && loc1 !== "Financial Statement" && isMatchingSession) return loc1;
    const loc2 = localStorage.getItem("project_name");
    if (loc2 && loc2 !== "Financial Statement" && isMatchingSession) return loc2;
    return "";
  };

  const [standaloneName, setStandaloneName] = useState(getInitialStandaloneName);
  const [workspaceName, setWorkspaceName] = useState(
    workspace_data?.response?.[0]?.workspace_name ||
    (isMatchingSession ? sessionStorage.getItem("adj_workspace_name") : "") ||
    localStorage.getItem("workspaceName") ||
    "Workspace"
  );
  const [workspaceId, setWorkspaceId] = useState(
    projectData?.workspace_id ||
    workspace_data?.response?.[0]?._id ||
    (isMatchingSession ? sessionStorage.getItem("adj_workspace_id") : "") ||
    localStorage.getItem("standalone_workspace_id") ||
    localStorage.getItem("ws_id") ||
    ""
  );

  const standaloneTargetLink = project_id ? `/templateV2/${project_id}` : (workspaceId ? `/financialstatement/${workspaceId}` : "/allWorkspace");

  const handleSaveExistingPreset = async (selectedPresets) => {
    const auth = localStorage.getItem("auth_token");
    const headers = {
      "x-auth-token": auth,
    };
    const currentProjectId = project_id || localStorage.getItem("project_id");
    let currentTbId = tb_id || localStorage.getItem("tb_id");

    if (!currentTbId && currentProjectId) {
      try {
        const res = await axios.get(`/api/v1/tb-mapping/get-tb/${currentProjectId}`, { headers });
        if (res?.data?.tb_id) {
          currentTbId = res.data.tb_id;
        }
      } catch (err) {
        console.error("Failed to fetch tb_id", err);
      }
    }

    if (!currentProjectId || !currentTbId) {
      setErrorTitle("Error");
      setErrorMessage("Project ID or TB ID is missing.");
      setShowErrorPopup(true);
      return false;
    }

    try {
      let lastResponse = null;
      for (const preset of selectedPresets) {
        const payload = {
          presetId: preset.id || preset._id,
          sourceProjectId: currentProjectId,
          sourceTbId: currentTbId,
        };
        lastResponse = await axios.post(
          "/api/v1/presets/overwrite-preset",
          payload,
          { headers }
        );
      }

      const count = selectedPresets.length;
      const successMsg =
        lastResponse?.data?.message ||
        (count === 1
          ? `Preset "${selectedPresets[0]?.name || "selected"}" overwritten successfully!`
          : `presets overwritten successfully!`);

      setSuccessMessage(successMsg);
      setShowSuccessPopup(true);
      return true;
    } catch (error) {
      console.error("Error overwriting preset:", error);
      const errMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to overwrite preset.";
      setErrorTitle("Error");
      setErrorMessage(errMsg);
      setShowErrorPopup(true);
      return false;
    }
  };

  const handleSaveNewPreset = async (newPresetName) => {
    const auth = localStorage.getItem("auth_token");
    const headers = {
      "x-auth-token": auth,
    };
    const currentProjectId = project_id || localStorage.getItem("project_id");
    let currentTbId = tb_id || localStorage.getItem("tb_id");

    if (!currentTbId && currentProjectId) {
      try {
        const res = await axios.get(`/api/v1/tb-mapping/get-tb/${currentProjectId}`, { headers });
        if (res?.data?.tb_id) {
          currentTbId = res.data.tb_id;
        }
      } catch (err) {
        console.error("Failed to fetch tb_id", err);
      }
    }

    if (!currentProjectId || !currentTbId) {
      setErrorTitle("Error");
      setErrorMessage("Project ID or TB ID is missing.");
      setShowErrorPopup(true);
      return false;
    }

    const fd = new FormData();
    fd.append("preset_name", newPresetName);

    try {
      const response = await axios.post(
        `/api/v1/presets/save-presets/${currentProjectId}/${currentTbId}`,
        fd,
        { headers }
      );
      setSuccessMessage(response?.data?.message || `Preset "${newPresetName}" has been created successfully!`);
      setShowSuccessPopup(true);
      return true;
    } catch (error) {
      console.error("Error saving preset:", error);
      const errMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to save preset.";
      setErrorTitle("Error");
      setErrorMessage(errMsg);
      setShowErrorPopup(true);
      return false;
    }
  };

  useEffect(() => {
    if (workspace_data?.response?.[0]?.workspace_name) {
      setWorkspaceName(workspace_data.response[0].workspace_name);
      sessionStorage.setItem("adj_workspace_name", workspace_data.response[0].workspace_name);
    }
    if (workspace_data?.response?.[0]?._id) {
      setWorkspaceId(workspace_data.response[0]._id);
      sessionStorage.setItem("adj_workspace_id", workspace_data.response[0]._id);
    }
  }, [workspace_data]);

  useEffect(() => {
    if (projectData?.project_name && projectData.project_name !== "Financial Statement") {
      setStandaloneName(projectData.project_name);
      sessionStorage.setItem("adj_standalone_name", projectData.project_name);
      localStorage.setItem("projectName", projectData.project_name);
    }
    if (projectData?.workspace_id) {
      setWorkspaceId(projectData.workspace_id);
      sessionStorage.setItem("adj_workspace_id", projectData.workspace_id);
    }
  }, [projectData]);

  useEffect(() => {
    const currentProjectId = project_id || sessionStorage.getItem("project_id") || localStorage.getItem("project_id");
    if (currentProjectId) {
      const auth = localStorage.getItem("auth_token");
      const headers = { "x-auth-token": auth };
      axios
        .get(`/api/v1/project/get-project-details/${currentProjectId}`, { headers })
        .then((res) => {
          const projectObj = res?.data?.project || res?.data;
          const pName = projectObj?.project_name || projectObj?.name || projectObj?.projectName;
          if (pName) {
            setStandaloneName(pName);
            sessionStorage.setItem("adj_standalone_name", pName);
            sessionStorage.setItem("adj_project_id", currentProjectId);
            localStorage.setItem("projectName", pName);
          }
          const wId = projectObj?.workspace_id || res?.data?.workspace?._id;
          if (wId) {
            setWorkspaceId(wId);
            sessionStorage.setItem("adj_workspace_id", wId);
          }
          const wName = res?.data?.workspace?.workspace_name;
          if (wName) {
            setWorkspaceName(wName);
            sessionStorage.setItem("adj_workspace_name", wName);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch project details for standalone topbar", err);
        });
    }
  }, [project_id]);

  const adjustmentBreadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`,
      className: "nav_cnt_color clickable",
    },
    {
      label: standaloneName || "Standalone",
      link: standaloneTargetLink,
      className: "nav_cnt_color clickable",
    },
    {
      label: "Cashflow Workings",
      onClick: onBackFromAdjustmentLog,
      className: "nav_cnt_color clickable",
    },
    {
      label: showAddAdjustment ? "Add New Adjustment" : "Adjustment Log",
      link: "",
      className: "headerLable",
    }
  ];

  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      {showBin ? (
        <div className={`${FSCss.listPageheader}`} style={{ paddingLeft: "15px" }}>
          <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
            <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
              <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "2px" }} onClick={onBackFromBin} />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => history.push(workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`)}>{workspaceName}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => history.push(standaloneTargetLink)}>{standaloneName || "Standalone"}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={onBackFromBin}>Standalone Financial Statements - {activeBinSection}</div>
            <div className={FSCss.iconDotContainer}>
              <GreenDot />
            </div>
            <div className={commoncss.headerLable} style={{ alignContent: "center", whiteSpace: "nowrap" }}>Deleted Items</div>
          </div>
          <div className={FSCss.headerRightContainer} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {selectedBinCount > 0 && (
              <span style={{ fontSize: '13px', fontWeight: 600, color: '#205a46', alignContent: 'center' }}>({selectedBinCount}) SELECTED</span>
            )}
            <Button
              btnColor={buttoncss.secondary}
              style={{ color: '#E30000', borderColor: '#CCD5D3', backgroundColor: "transparent" }}
              label="Delete Permanently "
              onClick={onDeletePermanently}
            />
            <Button
              btnColor={buttoncss.primary}
              label="Restore Selected Items"
              onClick={onRestoreSelected}
            />
          </div>
        </div>
      ) : showAdjustmentLog ? (
        <div className={`${FSCss.listPageheader}`} style={{ padding: "10px 15px", alignItems: "center" }}>
          <div className={FSCss.headerLeftContainer} style={{ width: "auto", display: "flex", alignItems: "center" }}>
            <Breadcrumb
              addCls="bgTransprent"
              p0={true}
              items={adjustmentBreadcrumbItems}
              headerActions={<></>}
              onBackClick={onBackFromAdjustmentLog}
            />
          </div>
          <div className={FSCss.headerRightContainer} id="adjustment-topbar-right"></div>
        </div>
      ) : showCashflowWorkings ? (
  <div className={`${FSCss.listPageheader}`}>
    <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
      <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
        <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "1px" }} onClick={onToggleCashflowWorkings} />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => history.push(workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`)}>{workspaceName}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => history.push(standaloneTargetLink)}>{standaloneName || "Standalone"}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={onToggleCashflowWorkings}>Standalone Financial Statements - Cashflow</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={commoncss.headerLable} style={{ alignContent: "center", whiteSpace: "nowrap" }}>Cashflow Workings</div>
    </div>
    <div className={FSCss.headerRightContainer}>
      <Button
        btnColor={buttoncss.secondary}
        style={{ backgroundColor: "transparent" }}
        label="Adjustment Log"
        onClick={onOpenAdjustmentLog}
      />
      &ensp;
      <Button
        btnColor={buttoncss.primary}
        label={
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <AddIcon />
            Add New Adjustment
          </span>
        }
        onClick={onAddAdjustment}
      />
    </div>
  </div>

) : (
  <div className={`${FSCss.listPageheader} ${activeCat === "socie" ? FSCss.socieHeaderFix : ""}`}>
    <div className={FSCss.headerLeftContainer} style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
      <div className={FSCss.iconContainer} style={{ width: "auto", paddingRight: "15px", paddingLeft: "0" }}>
        <BackArrow className="clickable" style={{ cursor: 'pointer', marginTop: "1px" }} onClick={() => history.push('/preview')} />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => history.push(workspaceId ? `/financialstatement/${workspaceId}` : `/allWorkspace`)}>{workspaceName}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={FSCss.topBarHeading} style={{ alignContent: "center", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => history.push(standaloneTargetLink)}>{standaloneName || "Standalone"}</div>
      <div className={FSCss.iconDotContainer}>
        <GreenDot />
      </div>
      <div className={commoncss.headerLable} style={{ alignContent: "center", whiteSpace: "nowrap" }}>Standalone Financial Statements - {getCategoryName(activeCat)}</div>
    </div>
    <div className={FSCss.headerRightContainer}>
      <Tooltip content="Go to mapping" variant="black" position="left" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center"}}>
        <button
          className="clickable"
          style={{ backgroundColor: "transparent", border: "none", padding: "0px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", minWidth: "unset", gap: 0, margin: 0, height: "100%" }}
          onClick={() => { history.push(`/templateV2/${project_id}`); }}
        >
          <span style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#2D8861", fontSize: "15px", paddingRight: "5px" }}>
            <ReplyIcon />
          </span>
        </button>
      </Tooltip>
      &ensp;
      {activeCat === "socie" && (
        <>
          <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent" }}
            label="Configure"
            onClick={() => setShowConfigureModal(true)}
          />
          &ensp;
        </>
      )}
      {activeCat !== "socie" && activeCat !== "cashflow" && (
        <>
          <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent", minWidth: "50px", padding: "8px 14px", margin: "0" }}
            label={
              <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "14px" }}>
                <RecycleBinIcon width={18} height={18} style={{ marginTop: "-1px" }} />
                 Bin
              </span>
            }
            onClick={onOpenBin}
          />
          &ensp;
          <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent", minWidth: "50px", padding: "8px 14px", margin: "0" }}
            label="Save Preset"
            onClick={() => setShowPresetChoiceModal(true)}
          />
          &ensp;
        </>
      )}
      {onToggleCashflowWorkings && (
        <>
           <Button
            btnColor={buttoncss.secondary}
            style={{ backgroundColor: "transparent" }}
            label="Cashflow Workings"
            onClick={onToggleCashflowWorkings}
          /> 
          &ensp;
        </>
      )}
      <Button
        btnColor={buttoncss.secondary}
        style={{ backgroundColor: "transparent" }}
        label="Link Registers"
        onClick={() => { history.push("/link-register"); }}
      />
      &ensp;
      <Button
        btnColor={buttoncss.primary}
        label="Finalise FS"
        onClick={() => { history.push("/finalize-fs"); }}
      />
    </div>
  </div>
)}
      <SocieConfigModal
        isOpen={showConfigureModal}
        onClose={() => setShowConfigureModal(false)}
        projectID={project_id}
        isTemplate={false}
        socieRows={socieRows}
        socieColumns={socieColumns}
        onSaveSuccess={onSocieConfigSaved}
      />
      <PresetChoiceModal
        isOpen={showPresetChoiceModal}
        onClose={() => setShowPresetChoiceModal(false)}
        onSelectExisting={() => setShowExistingPresetModal(true)}
        onSelectNew={() => setShowNewPresetModal(true)}
      />
      <ExistingPresetModal
        isOpen={showExistingPresetModal}
        onClose={() => setShowExistingPresetModal(false)}
        onSave={handleSaveExistingPreset}
        workspaceId={workspaceId}
      />
      <NewPresetModal
        isOpen={showNewPresetModal}
        onClose={() => setShowNewPresetModal(false)}
        onSave={handleSaveNewPreset}
      />
      <SuccessPopup
        isOpen={showSuccessPopup}
        onClose={() => setShowSuccessPopup(false)}
        message={successMessage}
      />
      <ErrorPopup
        isOpen={showErrorPopup}
        title={errorTitle}
        message={errorMessage}
        onClose={() => setShowErrorPopup(false)}
      />
      <DeletePopup
        isOpen={deleteConfirm !== null}
        title={deleteConfirm?.title}
        message={deleteConfirm?.message}
        onConfirm={deleteConfirm?.onConfirm}
        onCancel={() => setDeleteConfirm(null)}
      />
    </div>
  );
};

export default FSTopBar;